import { trigger, transition, style, animate, state } from '@angular/animations';
import { Subject, takeUntil } from 'rxjs';
import { ToastService } from 'src/app/core/toast/toast.service';
import { AppInfoRequest } from 'src/app/model/global-interface';
import { BaseResponse } from 'src/app/model/response/base-response';
import { GlobalService } from 'src/app/services/global.service';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { CustomgridOptions, GridColConfig } from 'src/app/core/custom-grid/custom-grid';
import { CustomGridComponent } from 'src/app/core/custom-grid/custom-grid.component';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { environment } from 'src/environments/environment';
import { CustomDialogComponent } from 'src/app/core/custom-dialog/custom-dialog.component';
import { EmailLogsResponse } from './email';
import { BrowserDetectorService } from 'src/app/services/browser-detector.service';
import { Router } from '@angular/router';
import { AppGlobalSettings, UserSettings, UserSettingsResponse } from './settings';
import { SettingsService } from './settings.service';
import { IdbService } from 'src/app/services/idb.service';
import { CustomTabs } from 'src/app/core/custom-tabs/custom-tabs';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  animations: [
    trigger('expandCollapseSidebar', [
      state('open', style({
        width: '300px',
        opacity: 1,
      })),
      state('closed', style({
        width: '5.5rem',
        opacity: 1
      })),state('mobile', style({
        width: '100%',
        opacity: 1
      })),
      transition('open <=> closed', [
        style({ overflow: 'hidden' }),
        animate('330ms cubic-bezier(0.25, 0.1, 0.25, 1)')
      ])
    ]),
    trigger('fadeSlide', [
      transition(':enter', [
        style({ opacity: 0, filter: "blur(40px)" }),
        animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ opacity: 1, filter: "blur(0)" })),
      ]),
      transition(':leave', [
        style({ opacity: 1, filter: "blur(0)" }),
        animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ opacity: 0, filter: "blur(40px)" })),
      ])
    ]),
    trigger('fadeInOutWithBlur', [
      transition(':enter', [
        style({ opacity: 0, filter: "blur(40px)" }),
        animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ opacity: 1, filter: "blur(0)" })),
      ]),
      transition(':leave', [
        style({ opacity: 1, filter: "blur(0)" }),
        animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ opacity: 0, filter: "blur(40px)" })),
      ])
    ])
  ]
})
export class SettingsComponent implements OnInit, OnDestroy, AfterViewInit {

  private theEnd$: Subject<void> = new Subject<void>();

  @ViewChild(CustomGridComponent) Cgrid: CustomGridComponent | undefined;
  @ViewChild('mailDialog') mailDialog: CustomDialogComponent | undefined;

  tabsFields: CustomTabs[] = [
    {
      title: 'Dati applicazione',
      routerOutlet: 'memory',
      
    },

    {
      title: 'Tema',
      routerOutlet: 'style',
      
    },

    {
      title: 'Anagrafiche',
      routerOutlet: 'anagrafiche',
      
    },
  ];

  ready: boolean = false;

  showMailLog: boolean = false;

  visibleData?: EmailLogsResponse;

  fuhrer: boolean = false;
  
  themeDark: boolean = false;

  version: string = environment.version;
  pageSettings: PageSettingsModel = {
    pageSize: 25,
    pageSizes: [25, 50, 100],
    pageCount: 1,
    currentPage: 1,
    totalRecordsCount: 100,
  };

  sidebarOpen: boolean = false;
  showText: boolean = false;
  isMobile: boolean = false;

  globalSettings: AppGlobalSettings | undefined;

  pageName: string = '';

  gridConfig: CustomgridOptions = {
    apiCallurl: 'api/user/email-log/get/lazy',
    rowsCallurl: '',
    apiTableName: ''
  }

  gridColConfig: GridColConfig[] = [
    {
      type: 'text',
      name: 'Destinatario',
      field: 'recipient',
      fieldOptions: {

      }
    },
    {
      type: 'text',
      name: 'Oggetto email',
      field: 'subject',
      fieldOptions: {

      }
    },

    {
      type: 'text',
      name: 'Anteprima email',
      field: 'bodyFormatted',
      fieldOptions: {

      }
    },
    {
      type: 'state',
      name: 'Ricevuta?',
      field: 'outcome',
      width: '30',
      fieldOptions: {

      }
    },
    {
      type: 'button',
      name: 'Visualizza',
      field: 'view',
      fieldOptions: {},
      width: '30',
      cssClass: "dl-button e-icons e-eye"
    }
  ];

  constructor(
    private localStorageS: LocalStorageService,
    private globalService: GlobalService,
    private toastService: ToastService,
    private browserService: BrowserDetectorService,
    private router: Router,
    private settingsService: SettingsService,
    private idbService: IdbService,
  ) {

  }

  hideShow() {

    this.showText = !this.showText
    setTimeout(() => {
      this.sidebarOpen = !this.sidebarOpen;
    }, 10);
    
  }


  ngOnInit(): void {
    setTimeout(() => {
      this.ready = true;
    }, 300);

    let urlArr = this.router.url.split('/');
    this.pageName = urlArr[urlArr.length - 1]

    let session = this.localStorageS.getSession();
    this.isMobile = this.browserService.detectBrowserMobile();

    this.localStorageS.setTitolo(`Impostazioni`);
    //this.router.navigate(['/home/settings/memory']);

    this.settingsService.GetSettings().pipe(takeUntil(this.theEnd$)).subscribe({
      next: (res: AppGlobalSettings) => {

        if (res != undefined) {
          this.globalSettings = res;
        }

      },
      error: () => {

      }
    });
  }
  
  updateLocalAppSettings() {

    // check if settings exist in the idb
    this.idbService.getAllData(environment.idbTables.GlobalSettings).then((res: any) => {
      console.warn("\n \n \n GOT THE DATA FROM IDB FOR SETTINGS \n \n \n");
      console.warn(res);

      if(res != undefined) {
        let resData: Array<any> = res;
        if(resData.length == 0) {

          this.settingsService.GetSettings().pipe(takeUntil(this.theEnd$)).subscribe({
            next: (res: AppGlobalSettings) => {
      
              if(res != undefined){
      
                // update or create settings in local idb
                this.idbService.addItemRow(environment.idbTables.GlobalSettings, res, environment.idbTables.GlobalSettings);
                this.globalSettings = res;
      
              }else{
                console.error("\n \n \n \n \n SHIT \n THERE ARE NO SETTINGS 💀💀💀💀💀💀💀💀💀💀💀💀💀💀 \n \n \n \n \n");
              }
      
            },
            error: () => {
      
            }
          });

        }else{
          console.info("SETTINGS ARE SETTED lol");
          this.globalSettings = res[0];
        }
      }

    });

    

  }
  ngAfterViewInit(): void {
    // check if the page need a double reload
    let ref = this.localStorageS.getValue("refresh");
    if (ref != null && ref != undefined) {
      this.localStorageS.deleteValue("refresh");
      location.reload();
    }
  }

  ngOnDestroy(): void {
    this.theEnd$.unsubscribe();
  }

  view(event: any) {
    console.log(event)
    let data: EmailLogsResponse = event.data;
    this.visibleData = data;
    this.mailDialog?.open();
  }



  navigateTo(linkPart: string) {
    this.router.navigate([`/home/settings/${linkPart}`]);
    this.pageName = linkPart;
  }

}
